import { render, staticRenderFns } from "./TerminalFeatures.vue?vue&type=template&id=46b1ef12"
import script from "./terminalFeatures.ts?vue&type=script&lang=js&external"
export * from "./terminalFeatures.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports